import App from "./componentes/App"
import  ReactDOM  from "react-dom"

ReactDOM.render(<App/>, document.querySelector('.root'))